// src/api/dashboard.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

// Crear instancia de axios con configuración
const dashboardApi = axios.create({
  baseURL: `${API_URL}/dashboard`,
});

// Interceptor para agregar el token
dashboardApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Obtener todas las estadísticas del dashboard
 */
export const getDashboardCompleto = async () => {
  const { data } = await dashboardApi.get('/');
  return data;
};

/**
 * Obtener estadísticas generales
 */
export const getEstadisticasGenerales = async () => {
  const { data } = await dashboardApi.get('/estadisticas');
  return data;
};

/**
 * Obtener productos más vendidos
 */
export const getProductosMasVendidos = async (limit = 5) => {
  const { data } = await dashboardApi.get('/productos-mas-vendidos', {
    params: { limit }
  });
  return data;
};

/**
 * Obtener ventas semanales
 */
export const getVentasSemanales = async () => {
  const { data } = await dashboardApi.get('/ventas-semanales');
  return data;
};

/**
 * Obtener ventas por establecimiento
 */
export const getVentasPorEstablecimiento = async () => {
  const { data } = await dashboardApi.get('/ventas-por-establecimiento');
  return data;
};

/**
 * Obtener ventas por usuario
 */
export const getVentasPorUsuario = async () => {
  const { data } = await dashboardApi.get('/ventas-por-usuario');
  return data;
};
